"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../createApi");

var BlogApi = function (_BaseApi) {
  (0, _inherits2["default"])(BlogApi, _BaseApi);

  function BlogApi() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, BlogApi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(BlogApi)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTag", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref.id,
          slug = _ref.slug,
          include = _ref.include,
          clientId = _ref.clientId,
          _ref$perPage = _ref.perPage,
          perPage = _ref$perPage === void 0 ? 25 : _ref$perPage;

      return _this.api.get("/v2/tags".concat(id ? "/".concat(id) : ''), {
        params: {
          clientId: clientId,
          include: include,
          slug: slug,
          per_page: perPage
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPost", function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref2.id,
          slug = _ref2.slug,
          clientId = _ref2.clientId;

      return _this.getPosts({
        clientId: clientId,
        id: id,
        slug: slug
      }).then(function (p) {
        return p.request;
      }).then(function (res) {
        return Array.isArray(res) ? res[0] : res;
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPosts", function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          id = _ref3.id,
          slug = _ref3.slug,
          categories = _ref3.categories,
          tags = _ref3.tags,
          perPage = _ref3.perPage,
          offset = _ref3.offset,
          page = _ref3.page,
          clientId = _ref3.clientId;

      return _this.api.get("/v2/posts".concat(id ? "/".concat(id) : ''), {
        params: {
          categories: categories,
          clientId: clientId,
          offset: offset,
          page: page,
          per_page: perPage,
          slug: slug,
          tags: tags
        }
      });
    });
    return _this;
  }

  return BlogApi;
}(_createApi.BaseApi);

var _default = BlogApi;
exports["default"] = _default;
//# sourceMappingURL=blog.js.map